'use client';

import { c as _c } from "react/compiler-runtime";
import './gallery-cinema.scss';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '@sola/ark-core/utils/helpers.ts';
import { FlexibleContentProps } from '@sola/schema/lib/schema.ts';
import { getHeaderDisplayLevel } from '@sola/utils/assembly.ts';
import { Carousel, CarouselContent, CarouselItem, CarouselLazyLoadImage, CarouselNext, CarouselPrevious } from '../../../molecules/carousel/carousel.tsx';
import { FeatureCard } from '../../../molecules/feature-card/feature-card.tsx';
import { HeaderGroup } from '../../../molecules/header-group/header-group.tsx';
import { Lightbox, LightboxTrigger } from '../../../molecules/lightbox/lightbox.tsx';
import { getPlaceholderItems } from '../../../utils/storybook.tsx';
import { getBaseSizeProps } from '../../../utils/text-utils.tsx';
import { JumbotronNotable } from '../../jumbotron/notable/jumbotron-notable.tsx';
export const GalleryCinema: React.FC<FlexibleContentProps> = t0 => {
  const $ = _c(34);
  const {
    seoLevel: t1,
    media,
    items,
    alt,
    ...props
  } = t0;
  const seoLevel = t1 === undefined ? 2 : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = ["skippy"];
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const {
    t
  } = useTranslation(t2);
  const hasHeaderContent = !!props.title || !!props.body;
  const hasHeaderCard = hasHeaderContent && media?.image;
  const hasHeaderGroup = hasHeaderContent && !media?.image;
  const headerDisplayLevel = getHeaderDisplayLevel(seoLevel);
  const galleryItems = !items || items.length < 1 ? getPlaceholderItems(items, 1) : items;
  const hasBodyItems = galleryItems.some(_temp);
  let t3;
  if ($[1] !== alt) {
    t3 = cn("GalleryCinema component", {
      "GalleryCinema--alt": alt
    });
    $[1] = alt;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = "GalleryCinema__container container flex flex-col gap-comfy-xl lg:gap-roomy-xs";
  const t5 = hasHeaderCard && <FeatureCard {...props} {...getBaseSizeProps(headerDisplayLevel)} seoLevel={seoLevel} media={media} imagePlacement="right" variant="horizontal" inline={true} />;
  const t6 = hasHeaderGroup && <HeaderGroup {...props} seoLevel={seoLevel} />;
  const T0 = Carousel;
  const t7 = t("skippy:gallery.title", {
    title: props.title
  });
  let t8;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      align: "start",
      loop: false,
      watchFocus: false
    };
    $[3] = t8;
  } else {
    t8 = $[3];
  }
  const t9 = "GalleryCinema__wrapper flex flex-col gap-comfy-lg";
  const t10 = cn("GalleryCinema__carousel", {
    "has-body": hasBodyItems
  });
  const t11 = galleryItems.length;
  let t12;
  if ($[4] !== alt || $[5] !== galleryItems || $[6] !== hasBodyItems || $[7] !== hasHeaderContent || $[8] !== seoLevel || $[9] !== t) {
    t12 = galleryItems.map((slide, index) => <CarouselItem key={["slide", index, slide.title].join("-")} index={index} className="GalleryCinema__slide" aria-label={`${t("skippy:gallery.slide.title", {
      index: index + 1,
      length: galleryItems.length
    })}${slide.title && ` - ${slide.title}`}`}><figure className="m-none"><Lightbox key={["lightbox", index, slide.title].join("-")} items={galleryItems} startIndex={index}><LightboxTrigger className="Lightbox__trigger  w-full" ariaLabel={t("skippy:gallery.open")}><>{!hasBodyItems && <div className="GalleryCinema__image"><CarouselLazyLoadImage index={index} media={slide.media} isVideoThumbnail={!!slide.media?.video} /></div>}{hasBodyItems && <JumbotronNotable seoLevel={hasHeaderContent ? seoLevel + 1 : seoLevel} {...{
                ...slide,
                alt,
                inline: true
              }} />}</></LightboxTrigger></Lightbox>{slide.media?.caption && <figcaption className="GalleryCinema__attribution label label-lg mt-comfy-sm">{slide.media.caption || slide.title}</figcaption>}</figure></CarouselItem>);
    $[4] = alt;
    $[5] = galleryItems;
    $[6] = hasBodyItems;
    $[7] = hasHeaderContent;
    $[8] = seoLevel;
    $[9] = t;
    $[10] = t12;
  } else {
    t12 = $[10];
  }
  let t13;
  if ($[11] !== t12) {
    t13 = <CarouselContent>{t12}</CarouselContent>;
    $[11] = t12;
    $[12] = t13;
  } else {
    t13 = $[12];
  }
  let t14;
  if ($[13] !== galleryItems.length || $[14] !== t10 || $[15] !== t13) {
    t14 = <div className={t10} data-length={t11}>{t13}</div>;
    $[13] = galleryItems.length;
    $[14] = t10;
    $[15] = t13;
    $[16] = t14;
  } else {
    t14 = $[16];
  }
  let t15;
  if ($[17] !== galleryItems.length) {
    t15 = galleryItems.length > 1 && <div className="GalleryCinema__arrows flex gap-comfy-sm items-center justify-end"><CarouselPrevious /><CarouselNext /></div>;
    $[17] = galleryItems.length;
    $[18] = t15;
  } else {
    t15 = $[18];
  }
  let t16;
  if ($[19] !== t14 || $[20] !== t15) {
    t16 = <div className={t9}>{t14}{t15}</div>;
    $[19] = t14;
    $[20] = t15;
    $[21] = t16;
  } else {
    t16 = $[21];
  }
  let t17;
  if ($[22] !== T0 || $[23] !== t16 || $[24] !== t7 || $[25] !== t8) {
    t17 = <T0 aria-label={t7} opts={t8}>{t16}</T0>;
    $[22] = T0;
    $[23] = t16;
    $[24] = t7;
    $[25] = t8;
    $[26] = t17;
  } else {
    t17 = $[26];
  }
  let t18;
  if ($[27] !== t17 || $[28] !== t5 || $[29] !== t6) {
    t18 = <div className={t4}>{t5}{t6}{t17}</div>;
    $[27] = t17;
    $[28] = t5;
    $[29] = t6;
    $[30] = t18;
  } else {
    t18 = $[30];
  }
  let t19;
  if ($[31] !== t18 || $[32] !== t3) {
    t19 = <section className={t3}>{t18}</section>;
    $[31] = t18;
    $[32] = t3;
    $[33] = t19;
  } else {
    t19 = $[33];
  }
  return t19;
};
function _temp(item) {
  return !!item.body;
}